"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function processRawSelectorFiltersFactory(escapeSelector) {
  return function (rawSelectorFilters) {
    return rawSelectorFilters.map(function (rawSelectorFilter) {
      var selectorFilter = {
        selector: "",
        replacement: undefined
      };
      var matchRegExpSelector = rawSelectorFilter.selector.match(/^\/(.+)\/([a-z]*)$/);

      if (matchRegExpSelector) {
        var pattern = escapeSelector(matchRegExpSelector[1], "\\\\");
        var flags = matchRegExpSelector[2];
        selectorFilter.selector = new RegExp(pattern, flags);
      } else {
        selectorFilter.selector = escapeSelector(rawSelectorFilter.selector);
      }

      selectorFilter.replacement = escapeSelector(rawSelectorFilter.replacement);
      return selectorFilter;
    });
  };
}

exports.processRawSelectorFiltersFactory = processRawSelectorFiltersFactory;